__turbopack_context__.v({
  "box": "LeadForm-module-scss-module__DRIOxq__box",
  "container": "LeadForm-module-scss-module__DRIOxq__container",
  "content": "LeadForm-module-scss-module__DRIOxq__content",
  "placeholder": "LeadForm-module-scss-module__DRIOxq__placeholder",
});
